import { GLOBAL_SEARCH_SELECTOR_WIDTH } from 'core/components/Header/GlobalSearch/constants';
import { LEFT_MENU_WIDTH } from 'theme/constants';

export const DEBOUNCE_TIME = 500;
export const LIST_HEIGHT = 'calc(100vh - 80px)';
export const LIST_WIDTH = 500;
export const LIST_HEADER_HEIGHT = 59;
export const MIN_CHARS_TO_SEARCH = 2;
export const PAGE_SIZE = 20;
export const SEARCH_DROPDOWN_Z_INDEX = 10;

const HEADER_HORIZONTAL_PADDING = 24;
const INLINE_PANEL_OFFSET =
  LEFT_MENU_WIDTH + 2 * HEADER_HORIZONTAL_PADDING + GLOBAL_SEARCH_SELECTOR_WIDTH + LIST_WIDTH;

export const INLINE_PANEL_WIDTH = `calc(100vw - ${INLINE_PANEL_OFFSET}px)`;
